import { render, staticRenderFns } from "./TabelOphthalmic.vue?vue&type=template&id=e0b03da0&"
import script from "./TabelOphthalmic.vue?vue&type=script&lang=js&"
export * from "./TabelOphthalmic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports